import React from 'react';

export const CheckboxOff = () => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="19" height="19" rx="4" fill="white" />
    <rect
      x="0.5"
      y="0.5"
      width="18"
      height="18"
      rx="3.5"
      stroke="#013E3E"
      strokeOpacity="0.2"
    />
  </svg>
);

export const CheckboxOn = () => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="19" height="19" rx="4" fill="#02706D" />
    <path
      d="M5 9.75L7.18182 12L13 6"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
